import React, { Component } from 'react'; import Dropdown from 'react-dropdown';
import {updateParameter} from 'operations/actions.js';
import ResolutionDropdown from './ResolutionDropdown.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import EffectParameterSlider from './EffectParameterSlider.js';
import {setContextualHelp} from "actions/index.js";
import { connect } from "react-redux";

class WarpEffectComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.props.effect.isEnabled();
    }

    onChangeResolution(resolution) {
        this.props.sequencerEngine.operationManager.dispatch(
            updateParameter(this.props.effect.resolutionParameter, resolution));
    }

    onChangeSliceRetrigger(retrigger) {
        document.activeElement.blur()
        this.props.effect.sliceRetrigger = !this.props.effect.sliceRetrigger;
        this.setState(this.state);
    }

    render() {
        return (
            <div>
              <ConditionedComponent condition={this.isEnabled()}>
                <div className="clear-fix"/>
                <ResolutionDropdown
                  automation={this.props.automation}
                  parameter={this.props.effect.resolutionParameter}
                  onChange={(r) => this.onChangeResolution(r)}/>
                <ConditionedComponent condition={!window.installation}>
                <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                  name={'Warp Speed'}
                  parameter={this.props.effect.warpLengthParameter}
                  automation={this.props.automation}
                  onParameterChanged={this.props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={0.01}
                  min={0.01}
                  max={16}/>
                <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                  name={'Warp Factor'}
                  parameter={this.props.effect.warpFactorParameter}
                  onParameterChanged={this.props.onParameterChanged}
                  automation={this.props.automation}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={0.5}
                  min={1}
                  max={8}/>
                </ConditionedComponent>
                <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                  name={'Loop Length'}
                  automation={this.props.automation}
                  parameter={this.props.effect.loopLengthParameter}
                  onParameterChanged={this.props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  unit='%'
                  step={0.1}
                  min={0.1}
                  max={100}/>
                <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                  name={'Grain Size'}
                  automation={this.props.automation}
                  parameter={this.props.effect.durationFactorParameter}
                  onParameterChanged={this.props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={0.01}
                  min={0.01}
                  max={2}/>
                <ConditionedComponent condition={!window.installation}>
                <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                  name={'Smoothness'}
                  parameter={this.props.effect.smoothnessParameter}
                  automation={this.props.automation}
                  onParameterChanged={this.props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={0.1}
                  min={0.1}
                  max={20}/>
                </ConditionedComponent>
                <div className="refined-checkbox-preferences">
                      <label>
                        <input 
                               type="checkbox"
                               value="reversed"
                               checked={this.props.effect.sliceRetrigger}
                               onChange={(e) => this.onChangeSliceRetrigger(e.target.value)} />
                          Slice Retrigger
                      </label>
                </div>
              </ConditionedComponent>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
    };
}
 
export default connect(null, mapDispatchToProps)(WarpEffectComponent);
